import { useEffect } from 'react';
type UseScrollToElementOnLoadProps = {
  elementId?: string;
  containerRef?: React.RefObject<HTMLElement>;
  behavior?: ScrollBehavior;
};

const useScrollToElementOnLoad = ({
  elementId,
  containerRef,
  behavior = 'smooth',
}: UseScrollToElementOnLoadProps) => {
  useEffect(() => {
    if (elementId) {
      const element = document.querySelector(`[id*="${elementId}"]`);
      if (element) {
        const elementRect = element.getBoundingClientRect();

        // Check if the element is fully visible vertically in the viewport
        const isFullyVisibleVertically =
          elementRect.top >= 0 && elementRect.bottom <= window.innerHeight;

        // Check if the element is fully visible horizontally in the container or window
        const container = containerRef?.current;

        const isFullyVisibleHorizontally = container
          ? elementRect.left >= container.getBoundingClientRect().left &&
          elementRect.right <= container.getBoundingClientRect().right
          : elementRect.left >= 0 && elementRect.right <= window.innerWidth;

        if (!isFullyVisibleVertically) {
          const offsetTop = elementRect.top + window.scrollY - window.innerHeight / 2 + elementRect.height / 2;

          window.scrollTo({
            top: offsetTop,
            behavior,
          });
        }
        if (!isFullyVisibleHorizontally && container) {
          const containerRect = container.getBoundingClientRect();
          const offsetLeft = elementRect.left - containerRect.left + container.scrollLeft;

          container.scrollTo({
            left: offsetLeft,
            behavior,
          });
        }
      }
    }
  }, [elementId, containerRef, behavior]);
};

export default useScrollToElementOnLoad;
